const InventoryUnit = {

    // FIELDS
    "inventory_unit": "Inventory Unit",
    "name": "Name",
    "short_name": "Short Name",
    "description": "Description",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "list_title": "Inventory Unit",
    "filter_title": "Inventory Unit Filter",

    // TABLE HEADER
    "table_name": "Name",
    "table_short_name": "Short Name",
    "table_description": "Description",

    // ERROR
    "error_name": "Enter Inventory Unit Name",
    "error_short_name": "Enter Short Name",
    "error_description": "Enter Description",
    "error_status": "Select Status",

}

export default InventoryUnit;

